import React, { useEffect} from 'react';
import { Checkbox, Row, Menu, Col } from 'antd';
import { Area, Categoria } from '../../../../../models/JuradosModel/jurados.model';
import { UseVerConvocatorias } from "../../../../../hooks/UseVerConvocatorias";
import './menu-categorias.style.scss';

const { SubMenu } = Menu;

type MenuCategoriasProps = {
    areas: any[],
    handleCheckBoxChange: Function,
    categoriasSelected: Categoria[],
    refCheckBox: any,
    counter: number
    areaprincipal: any
}

export const MenuCategorias = ({ areas, handleCheckBoxChange, categoriasSelected, refCheckBox, counter, areaprincipal }: MenuCategoriasProps) => {
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();

  useEffect(() => {
    getConvocatoriaPersistente();
  }, []);

    let checkeds = areas.map((area: any) => {
        let result = area.categorias_areas.filter((check: any) => check.checked === true)
        return result.length
    });
    let result = 0
        for (var i in checkeds) {
            result = result + checkeds[i];
        }
    console.log(result,'categoriasselectec')
    return (
        <>
            {!(convocatoria.nombre_convocatoria.includes('Altavoz')) && (
              <div className="row d-flex justify-content-between mb-2">
                <div className="col-12 col-md-6 justify-content-between">
                    <div>Categorías de conocimiento - <span className='font-size-10px'>Selecciona hasta 3</span></div>
                </div>
                <div className="col-12 col-md-6 d-flex justify-content-md-end font-family-Montserrat-Regular">
                    Seleccionado <span style={{color:"#ff8403", paddingLeft:"5px"}}>({result}/3)</span>
                </div>
              </div>
            )}
            {convocatoria.nombre_convocatoria.includes('Altavoz') && (
              <div className="row d-flex justify-content-between mb-2">
                <div className="col-12 col-md-6 justify-content-between">
                    <div>Categorías de conocimiento - <span className='font-size-10px'>Selecciona hasta 1</span></div>
                </div>
                <div className="col-12 col-md-6 d-flex justify-content-md-end font-family-Montserrat-Regular">
                    Seleccionado <span style={{color:"#ff8403", paddingLeft:"5px"}}>({result}/1)</span>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12">
                <Menu
                    mode="inline"
                    className="menu"
                >
                    {areas?.map((area, indexprincipal: number) =>
                    area.id_area == areaprincipal &&
                        (<SubMenu key={area.id} title={
                            <div>
                                {indexprincipal + 1}. {area.nombre_area} <span>({area.categorias_areas.length})</span>
                            </div>
                        }>
                            <div className="container__categorias__item">
                                {area.categorias_areas.map((categoria : any, index: number) =>
                                    <Checkbox value={categoria.checked} checked={categoria.checked} onChange={(e) => handleCheckBoxChange(e.target.checked, categoria.nombre, area.categorias_areas, indexprincipal, index)} className="check__categoria" style={{ margin: '6px' }} key={categoria.id_categoria}>
                                        <span className='lh-sm font-family-Montserrat-Regular'> {categoria.nombre}</span>
                                    </Checkbox>
                                )}
                            </div>
                        </SubMenu>)
                    )}
                </Menu>
              </div>
            </div>

        </>
    )
}
